export const REPORTS_PER_PAGE = 20;

export const STATUS_FILTERS = [
    { value: 'in_progress', label: 'Em Andamento' },
    { value: 'completed', label: 'Concluído' },
    { value: 'all', label: 'Todos' },
];
